<template>
    <float-on-mask tag="div" :float-up="true" class="g-mb-8">
        <g-typography tag="h2" size="h4" color="normal" font-weight="bold" :value="heading" class="g-mb-3" />
        <affiliate-link-display v-for="link in linksToDisplay" :key="link.id" :link="link" class="g-mb-5" />
        <div v-if="affiliateLinks.length > 10" class="align-right">
            <g-pagination
                class="g-mx-auto"
                size="small"
                :current="page"
                :total="affiliateLinks.length"
                :page-size="pageSize"
                :disabled="isLoading"
                @change="updateLinks"
            />
        </div>
    </float-on-mask>
</template>

<script>
    import FloatOnMask from '../../../library/FloatOnMask.vue';
    import AffiliateLinkDisplay from './AffiliateLinkDisplay.vue';

    export default {
        name: 'AffiliateLinksDisplay',
        components: {
            FloatOnMask,
            AffiliateLinkDisplay
        },
        props: {
            affiliateLinks: {
                type: Array,
                default: () => []
            },
            isLoading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            const heading = `Your Links (${this.affiliateLinks.length})`;
            const page = 1;
            const pageSize = 10;
            const totalPages = Math.ceil(this.affiliateLinks.length / 10);
            const linksToDisplay = [];
            return {
                heading,
                page,
                pageSize,
                totalPages,
                linksToDisplay
            };
        },
        methods: {
            updateLinks(page) {
                this.page = page;
                this.getDisplayedLinks();
            },
            getDisplayedLinks() {
                this.linksToDisplay = this.affiliateLinks.slice(
                    (this.page - 1) * this.pageSize,
                    Math.min(this.page * this.pageSize, this.affiliateLinks.length)
                );
            }
        },
        created() {
            this.getDisplayedLinks();
        }
    };
</script>

<style>
    .align-right {
        display: flex;
        justify-content: flex-end;
    }
</style>
